import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_9a184993-e139-401a-986a-f8246bd6749d/artifacts/nc2uap7k_HC.jpeg";

export function Logo({ compact = false, to = "/" }) {
  return (
    <Link
      data-testid={NAV.logo}
      to={to}
      className="flex items-center gap-2 group"
      aria-label="Hyderabad Crackers home"
    >
      <img
        src={LOGO_SRC}
        alt="Hyderabad Crackers"
        className={`${compact ? "h-8" : "h-9 sm:h-11"} w-auto object-contain rounded-md`}
        style={{ background: "#000" }}
      />
    </Link>
  );
}
